
import { useState } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO';

const guides = [
  {
    id: 1,
    title: "Heights History Walk",
    description: "A 2-hour loop highlighting historic architecture, remnants of Houston's streetcar system, and local cafés.",
    duration: "2 hours",
    category: "History",
    tags: ["Neighborhood", "History", "Short outings"],
    difficulty: "Easy",
    image: "https://public.readdy.ai/ai/img_res/aa80720b7672406c1fefd696b573dea3.jpg"
  },
  {
    id: 2,
    title: "Buffalo Bayou By Afternoon",
    description: "A 3-hour kid-friendly skyline loop through Houston's premier urban park with nature trails and city views.",
    duration: "3 hours",
    category: "Nature",
    tags: ["Nature", "Kid-friendly", "Free"],
    difficulty: "Easy",
    image: "https://readdy.ai/api/search-image?query=Buffalo%20Bayou%20Park%20in%20Houston%20with%20downtown%20skyline%20view%2C%20families%20walking%20on%20trails%2C%20green%20natural%20spaces%2C%20afternoon%20light%2C%20kid-friendly%20outdoor%20setting%2C%20peaceful%20urban%20nature%20scene&width=400&height=300&seq=bayou-guide-hub&orientation=landscape"
  },
  {
    id: 3,
    title: "East End Taquería Trail",
    description: "6 authentic taco stops showcasing Houston's Mexican culinary heritage and neighborhood history.",
    duration: "4 hours",
    category: "Food",
    tags: ["Food", "Neighborhood", "History"],
    difficulty: "Easy",
    image: "https://readdy.ai/api/search-image?query=Houston%20East%20End%20neighborhood%20with%20authentic%20Mexican%20taqueria%20storefronts%2C%20colorful%20murals%2C%20street%20food%20culture%2C%20vibrant%20community%20atmosphere%2C%20local%20flavor%20and%20cultural%20heritage&width=400&height=300&seq=eastend-guide-hub&orientation=landscape"
  },
  {
    id: 4,
    title: "Museum District Cultural Walk",
    description: "Explore Houston's renowned Museum District with stops at major institutions and hidden architectural gems.",
    duration: "5 hours",
    category: "History",
    tags: ["History", "Free", "Short outings"],
    difficulty: "Easy",
    image: "https://readdy.ai/api/search-image?query=Houston%20Museum%20District%20with%20modern%20architecture%2C%20cultural%20institutions%2C%20tree-lined%20streets%2C%20visitors%20walking%20between%20museums%2C%20afternoon%20light%2C%20educational%20and%20cultural%20atmosphere&width=400&height=300&seq=museum-guide&orientation=landscape"
  },
  {
    id: 5,
    title: "Memorial Park Nature Loop",
    description: "A comprehensive tour of Houston's largest urban park featuring trails, wildlife, and recreational areas.",
    duration: "3 hours",
    category: "Nature",
    tags: ["Nature", "Kid-friendly", "Free"],
    difficulty: "Moderate",
    image: "https://readdy.ai/api/search-image?query=Memorial%20Park%20Houston%20with%20running%20trails%2C%20towering%20trees%2C%20joggers%20and%20families%2C%20natural%20green%20spaces%2C%20golden%20hour%20lighting%2C%20peaceful%20urban%20forest%20setting&width=400&height=300&seq=memorial-guide&orientation=landscape"
  },
  {
    id: 6,
    title: "Montrose Art & Culture Tour",
    description: "Discover Houston's creative heart through galleries, street art, and cultural landmarks in the Montrose area.",
    duration: "4 hours",
    category: "History",
    tags: ["Neighborhood", "History", "Short outings"],
    difficulty: "Easy",
    image: "https://readdy.ai/api/search-image?query=Montrose%20Houston%20neighborhood%20with%20art%20galleries%2C%20colorful%20street%20murals%2C%20creative%20cultural%20spaces%2C%20people%20exploring%20art%20venues%2C%20vibrant%20artistic%20community%20atmosphere&width=400&height=300&seq=montrose-guide&orientation=landscape"
  },
  {
    id: 7,
    title: "Halloween Heights Ghost Walk",
    description: "A spine-tingling evening tour through the Heights' most haunted locations, featuring local ghost stories and historic Halloween traditions.",
    duration: "2 hours",
    category: "History",
    tags: ["Neighborhood", "History", "Seasonal", "Halloween"],
    difficulty: "Easy",
    image: "https://readdy.ai/api/search-image?query=Houston%20Heights%20neighborhood%20at%20twilight%20during%20Halloween%20season%20with%20historic%20bungalow%20houses%20decorated%20for%20Halloween%2C%20orange%20autumn%20leaves%2C%20spooky%20decorations%2C%20jack-o-lanterns%20on%20porches%20evening%20atmosphere%20with%20warm%20street%20lights%2C%20family-friendly%20Halloween%20vibes&width=400&height=300&seq=halloween-heights-hub&orientation=landscape"
  },
  {
    id: 8,
    title: "Buffalo Bayou Fall Foliage Tour",
    description: "Experience Houston's autumn colors along the bayou with seasonal wildlife viewing, harvest activities, and fall photography spots.",
    duration: "3 hours",
    category: "Nature",
    tags: ["Nature", "Kid-friendly", "Free", "Seasonal", "Fall"],
    difficulty: "Easy",
    image: "https://readdy.ai/api/search-image?query=Buffalo%20Bayou%20Park%20Houston%20in%20autumn%20with%20colorful%20fall%20foliage%2C%20families%20walking%20on%20trails%20with%20children%20in%20light%20jackets%2C%20golden%20and%20orange%20leaves%20on%20trees%20downtown%20Houston%20skyline%20in%20background%2C%20crisp%20fall%20weather%2C%20seasonal%20beauty&width=400&height=300&seq=bayou-fall-hub&orientation=landscape"
  },
  {
    id: 9,
    title: "Houston Pumpkin Patch & Farm Trail",
    description: "Visit authentic working farms around Houston for pumpkin picking, corn mazes, and fall harvest experiences perfect for families.",
    duration: "4 hours",
    category: "Nature",
    tags: ["Nature", "Kid-friendly", "Seasonal", "Fall", "Halloween"],
    difficulty: "Easy",
    image: "https://readdy.ai/api/search-image?query=Houston%20area%20pumpkin%20patch%20with%20families%20picking%20pumpkins%2C%20orange%20pumpkins%20scattered%20across%20farm%20fields%2C%20corn%20maze%20in%20background%2C%20children%20playing%20in%20autumn%20setting%2C%20harvest%20festival%20atmosphere%20with%20hay%20bales%20and%20fall%20decorations&width=400&height=300&seq=pumpkin-patch&orientation=landscape"
  },
  {
    id: 10,
    title: "Downtown Houston Halloween Historic Tour",
    description: "Explore downtown's spookiest stories and haunted buildings, from the Rice Hotel to Main Street's ghostly past.",
    duration: "2.5 hours",
    category: "History",
    tags: ["History", "Seasonal", "Halloween", "Short outings"],
    difficulty: "Easy",
    image: "https://readdy.ai/api/search-image?query=Downtown%20Houston%20at%20dusk%20during%20Halloween%20season%20with%20historic%20buildings%20lit%20dramatically%2C%20vintage%20architecture%20creating%20spooky%20shadows%2C%20urban%20Halloween%20atmosphere%20with%20decorated%20storefronts%2C%20pedestrians%20in%20light%20Halloween%20costumes%2C%20moody%20evening%20lighting&width=400&height=300&seq=downtown-halloween&orientation=landscape"
  }
];

const categories = ["All", "History", "Nature", "Food"];
const tags = ["Neighborhood", "Food", "History", "Nature", "Free", "Kid-friendly", "Short outings", "Seasonal", "Halloween", "Fall"];

export default function Guides() {
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [selectedTags, setSelectedTags] = useState<string[]>([]);

  const filteredGuides = guides.filter((guide) => {
    const categoryMatch = selectedCategory === "All" || guide.category === selectedCategory;
    const tagMatch = selectedTags.length === 0 || selectedTags.some((tag) => guide.tags.includes(tag));
    return categoryMatch && tagMatch;
  });

  const toggleTag = (tag: string) => {
    setSelectedTags((prev) =>
      prev.includes(tag) ? prev.filter((t) => t !== tag) : [...prev, tag]
    );
  };

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: "Houston Exploration Guides",
    description:
      "Browse guides to Houston's neighborhoods, outdoor spaces, and cultural experiences. Each includes context, history, and practical details.",
    url: `${import.meta.env.VITE_SITE_URL}/guides`,
    mainEntity: {
      "@type": "ItemList",
      itemListElement: guides.map((guide, index) => ({
        "@type": "ListItem",
        position: index + 1,
        item: {
          "@type": "TouristAttraction",
          name: guide.title,
          description: guide.description,
          url: `${import.meta.env.VITE_SITE_URL}/guides/${guide.id}`
        }
      }))
    }
  };

  return (
    <div className="min-h-screen bg-neutral-100">
      <SEO
        title="Houston Exploration Guides - Eric Javidi"
        description="Browse guides to Houston's neighborhoods, outdoor spaces, and cultural experiences. Heights History Walk, Buffalo Bayou trails, East End taquerías, and more."
        keywords="Houston guides, Houston tours, Heights Houston, Buffalo Bayou, East End Houston, Museum District, Memorial Park, Montrose Houston"
        ogTitle="Houston Exploration Guides - Eric Javidi"
        ogDescription="Browse guides to Houston's neighborhoods, outdoor spaces, and cultural experiences."
        ogUrl={`${import.meta.env.VITE_SITE_URL}/guides`}
        twitterTitle="Houston Exploration Guides - Eric Javidi"
        twitterDescription="Browse guides to Houston's neighborhoods, outdoor spaces, and cultural experiences."
        jsonLd={jsonLd}
      />

      {/* Navigation */}
      <nav className="bg-neutral-800 shadow-lg">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <Link to="/" className="text-xl font-semibold text-white">
                Eric Javidi
              </Link>
            </div>
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-8">
                <Link
                  to="/"
                  className="text-neutral-300 hover:text-green-400 px-3 py-2 text-sm font-medium"
                >
                  Home
                </Link>
                <Link
                  to="/about"
                  className="text-neutral-300 hover:text-green-400 px-3 py-2 text-sm font-medium"
                >
                  About
                </Link>
                <Link
                  to="/guides"
                  className="text-white hover:text-green-400 px-3 py-2 text-sm font-medium"
                >
                  Guides
                </Link>
                <Link
                  to="/fall-festivals"
                  className="text-neutral-300 hover:text-green-400 px-3 py-2 text-sm font-medium"
                >
                  Fall Festivals
                </Link>
                <Link
                  to="/resources"
                  className="text-neutral-300 hover:text-green-400 px-3 py-2 text-sm font-medium"
                >
                  Resources
                </Link>
                <Link
                  to="/contact"
                  className="text-neutral-300 hover:text-green-400 px-3 py-2 text-sm font-medium"
                >
                  Contact
                </Link>
              </div>
            </div>
            <div className="md:hidden">
              <button className="text-neutral-300 hover:text-white">
                <i className="ri-menu-line text-xl"></i>
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Header */}
      <section className="py-16 bg-neutral-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-4xl lg:text-5xl font-bold text-neutral-800 mb-6">
              All Guides
            </h1>
            <p className="text-lg text-neutral-600">
              Browse guides to Houston's neighborhoods, outdoor spaces, and cultural experiences. Each includes context, history, and practical details.
            </p>
          </div>
        </div>
      </section>

      {/* Filters */}
      <section className="py-8 bg-neutral-200 border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Category Filters */}
          <div className="mb-6">
            <h3 className="text-sm font-medium text-neutral-800 mb-3">
              Category
            </h3>
            <div className="flex flex-wrap gap-2">
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => setSelectedCategory(category)}
                  className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer ${
                    selectedCategory === category
                      ? "bg-green-600 text-white"
                      : "bg-neutral-50 text-neutral-600 hover:bg-neutral-100"
                  }`}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>

          {/* Tag Filters */}
          <div>
            <h3 className="text-sm font-medium text-neutral-800 mb-3">
              Tags
            </h3>
            <div className="flex flex-wrap gap-2">
              {tags.map((tag) => (
                <button
                  key={tag}
                  onClick={() => toggleTag(tag)}
                  className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer ${
                    selectedTags.includes(tag)
                      ? "bg-green-100 text-green-800 ring-2 ring-green-600"
                      : "bg-neutral-50 text-neutral-600 hover:bg-neutral-100"
                  }`}
                >
                  {tag}
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Guides Grid */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredGuides.map((guide) => (
              <Link
                key={guide.id}
                to={`/guides/${guide.id}`}
                className="bg-neutral-50 rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-shadow cursor-pointer"
              >
                <div
                  className="h-48 bg-cover bg-center relative"
                  style={{ backgroundImage: `url('${guide.image}')` }}
                >
                  <div className="absolute inset-0 bg-gradient-to-t from-neutral-800/30 to-transparent"></div>
                </div>
                <div className="p-6">
                  <div className="flex items-center justify-between mb-2">
                    <span
                      className={`px-2 py-1 text-xs font-medium rounded-full ${
                        guide.category === "History"
                          ? "bg-blue-100 text-blue-800"
                          : guide.category === "Nature"
                          ? "bg-green-100 text-green-800"
                          : "bg-orange-100 text-orange-800"
                      }`}
                    >
                      {guide.category}
                    </span>
                    <span className="text-xs text-neutral-500">
                      {guide.difficulty}
                    </span>
                  </div>
                  <h3 className="text-xl font-semibold text-neutral-800 mb-2">
                    {guide.title}
                  </h3>
                  <p className="text-neutral-600 mb-4 text-sm">
                    {guide.description}
                  </p>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center text-sm text-neutral-500">
                      <i className="ri-time-line mr-1"></i>
                      <span>{guide.duration}</span>
                    </div>
                    <div className="flex items-center text-green-600">
                      <span className="text-sm font-medium">Read Guide</span>
                      <i className="ri-arrow-right-line ml-1"></i>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          {filteredGuides.length === 0 && (
            <div className="text-center py-12">
              <div className="w-16 h-16 bg-neutral-200 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-search-line text-2xl text-neutral-400"></i>
              </div>
              <h3 className="text-lg font-medium text-neutral-800 mb-2">
                No guides found
              </h3>
              <p className="text-neutral-600">
                Try adjusting your filters to see more results.
              </p>
            </div>
          )}
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-neutral-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div className="md:col-span-2">
              <h3 className="text-xl font-semibold mb-4">Eric Javidi</h3>
              <p className="text-neutral-300 mb-4">
                Houston-based storyteller exploring where the city's history meets its natural landscapes.
              </p>
              <div className="flex items-center space-x-4">
                <a
                  href="https://www.youtube.com/@EricJavidi"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-neutral-300 hover:text-red-400 transition-colors"
                  aria-label="YouTube Channel"
                >
                  <i className="ri-youtube-fill text-2xl"></i>
                </a>
              </div>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Quick Links</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/about" className="text-neutral-300 hover:text-white">
                    About
                  </Link>
                </li>
                <li>
                  <Link to="/guides" className="text-neutral-300 hover:text-white">
                    Guides
                  </Link>
                </li>
                <li>
                  <Link to="/fall-festivals" className="text-neutral-300 hover:text-white">
                    Fall Festivals
                  </Link>
                </li>
                <li>
                  <Link to="/resources" className="text-neutral-300 hover:text-white">
                    Resources
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="text-neutral-300 hover:text-white">
                    Contact
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Connect</h4>
              <ul className="space-y-2">
                <li><a href="https://www.youtube.com/@EricJavidi" target="_blank" rel="noopener noreferrer" className="text-neutral-300 hover:text-white">YouTube Channel</a></li>
                <li>
                  <a href="https://readdy.ai/?origin=logo" className="text-neutral-300 hover:text-white">
                    Made with Readdy
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="border-t border-neutral-700 mt-8 pt-8 text-center">
            <p className="text-neutral-400">© 2024 Eric Javidi. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
